var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_204_706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.8731 49.0557C41.2876 49.0557 50.5408 40.0743 50.5408 28.9952C50.5408 17.9161 41.2876 8.93469 29.8731 8.93469C18.4586 8.93469 9.20532 17.9161 9.20532 28.9952C9.20532 40.0743 18.4586 49.0557 29.8731 49.0557Z",
    fill: "#7A79B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.492 43.1846C36.4203 51.0191 23.3356 51.0191 15.264 43.1846C7.19229 35.3501 7.19229 22.6498 15.264 14.8153L44.492 43.1846Z",
    fill: "#737099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.75594 49.5012C-2.91181 38.1762 -2.91181 19.8135 8.75594 8.48858C20.4237 -2.83636 39.3423 -2.83636 51.01 8.48858L8.75594 49.5012Z",
    fill: "#34337E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.873 29.0047L8.7557 49.5015C-2.91206 38.1765 -2.91206 19.8138 8.7557 8.48889L29.873 29.0047Z",
    fill: "#232459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M50.9999 49.5014C39.3322 60.8263 20.4136 60.8263 8.74585 49.5014L29.8729 28.9951L50.9999 49.5014Z",
    fill: "#CE2F30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.4919 43.1845C36.4203 51.019 23.3356 51.019 15.2639 43.1845L29.873 29.0046L44.4919 43.1845Z",
    fill: "#832929"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e3127e0a3d046b5ac122a4c37244b64d.svg";
export { ForwardRef as ReactComponent };